<template>
  <div class="card-body">
    <div>
      <div class="row">
        <div class="col-lg-12">
          <div>
            <div>
              <div class="alert alert-info text-center">
                <p class="mb-0">Please comma separate email addresses</p>
              </div>
              <inputbox
                name="to"
                label="To"
                v-model="form.to"
                :show-error="form.errors.has('to')"
                :error-message="form.errors.get('to')"
                helper="Please enter the email addresses you would like to send the email to."
              ></inputbox>
              <inputbox
                name="cc"
                label="CC"
                v-model="form.cc"
                helper="Please enter the email addresses you would like to send a carbon copy."
              ></inputbox>
              <inputbox
                name="subject"
                label="Subject"
                v-model="form.subject"
                :show-error="form.errors.has('subject')"
                helper="Please enter the subject of the email address."
                :error-message="form.errors.get('subject')"
              ></inputbox>
              <input-block
                name="body"
                label="Message"
                v-model="form.body"
                :show-error="form.errors.has('body')"
                helper="Please enter content of the email."
                :error-message="form.errors.get('body')"
              ></input-block>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div>
            <fieldset>
              <legend>
                Attachments
                <button
                  class="btn btn-xs btn-primary float-right"
                  v-on:click.prevent="openAddAttachmentModal"
                >
                  Add Attachment
                </button>
              </legend>
            </fieldset>
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-bind:key="index"
                  v-for="(document, index) in form.documents"
                >
                  <td v-text="document.type.label"></td>
                  <td>
                    <button
                      class="btn btn-primary btn-xs"
                      v-on:click.prevent="viewDocument(document)"
                    >
                      Preview
                    </button>
                    <button
                      class="btn btn-danger btn-xs"
                      v-on:click.prevent="detachDocument(document)"
                    >
                      Detach
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div>
            <fieldset>
              <legend>
                Documents
                <button
                  class="btn btn-xs btn-primary float-right"
                  v-on:click.prevent="openAddDocumentModal"
                >
                  Add Document
                </button>
              </legend>
            </fieldset>
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-bind:key="index"
                  v-for="(document, index) in form.documentTemplates"
                >
                  <td v-text="document.name"></td>
                  <td>
                    <button
                      class="btn btn-danger btn-xs"
                      v-on:click.prevent="detachDocumentTemplate(document)"
                    >
                      Detach
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <button class="btn btn-primary btn-sm" v-on:click.prevent="sendEmail">
          Send Email
        </button>
      </div>
    </div>
    <modal :show="modals.attachment" :large="true" :fire-event="false">
      <h4 slot="title">Add Attachment</h4>
      <div>
        <div class="alert alert-info" v-if="availableDocuments.length === 0">
          <span>Sorry, there are no documents available</span>
        </div>
        <selectlist
          :options="availableDocuments"
          key-name="identifier"
          label="Attachment"
          helper="Please select a document to attach from the list."
          label-name="type_label"
          v-model="selectedAttachment"
          name="attachment"
          placeholder="Please Select"
          :required="true"
          :show-error="showAttachmentError"
          error-message="You must select an attachment to add."
        >
          <div slot="rightBtn">
            <button
              class="btn btn-primary"
              :disabled="!selectedAttachment"
              v-on:click.prevent="previewChosenAttachment"
            >
              Preview
            </button>
          </div>
        </selectlist>
      </div>
      <div class="footer" slot="footer">
        <button
          class="btn btn-danger float-left"
          v-on:click.prevent="resetModalDetails"
        >
          Close
        </button>
        <button
          class="btn btn-primary"
          :disabled="!selectedAttachment"
          v-on:click.prevent="addAttachmentToList"
        >
          Attach File
        </button>
      </div>
    </modal>
    <modal :show="modals.document" :large="true" :fire-event="false">
      <h4 slot="title">Add Document</h4>
      <div>
        <div
          class="alert alert-info"
          v-if="availableDocumentTemplates.length === 0"
        >
          <span>Sorry, there are no documents available</span>
        </div>
        <selectlist
          :options="availableDocumentTemplates"
          key-name="identifier"
          label="Document"
          helper="Please select a document to attach from the list."
          label-name="name"
          v-model="selectedDocument"
          name="documentTemplate"
          placeholder="Please Select"
          :required="true"
          :show-error="showDocumentError"
          error-message="You must select a document to add."
        >
        </selectlist>
      </div>
      <div class="footer" slot="footer">
        <button
          class="btn btn-danger float-left"
          v-on:click.prevent="resetDocumentModalDetails"
        >
          Close
        </button>
        <button
          class="btn btn-primary"
          :disabled="!selectedDocument"
          v-on:click.prevent="addDocumentToList"
        >
          Attach Document
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      modals: {
        attachment: false,
        document: false
      },
      form: new window.Form({
        to: null,
        cc: null,
        subject: '',
        body: '',
        documents: [],
        documentTemplates: []
      }),
      documents: [],
      documentTemplates: [],
      selectedAttachment: null,
      selectedDocument: null,
      showAttachmentError: false,
      showDocumentError: false
    };
  },

  mounted() {
    this.getDocuments();
    this.getDocumentTemplates();
  },

  computed: {
    availableDocuments() {
      return this.documents.filter(document => {
        return (
          this.form.documents.findIndex(record => {
            return record.identifier === document.identifier;
          }) === -1
        );
      });
    },

    availableDocumentTemplates() {
      return this.documentTemplates.filter(document => {
        return (
          this.form.documentTemplates.findIndex(record => {
            return record.identifier === document.identifier;
          }) === -1
        );
      });
    }
  },

  methods: {
    previewChosenAttachment() {
      if (this.selectedAttachment) {
        this.previewDocument(this.selectedAttachment);
      }
    },

    previewDocument(identifier) {
      window.open(
        `${window.AxisUK.api}incidents/${
          this.incident
        }/documents/${identifier}?token=${window.window.Token.get()}`,
        '_blank'
      );
    },

    resetModalDetails() {
      this.modals.attachment = false;
      this.selectedAttachment = null;
      this.showAttachmentError = false;
    },

    resetDocumentModalDetails() {
      this.modals.document = false;
      this.selectedDocument = null;
      this.showDocumentError = false;
    },

    addAttachmentToList() {
      if (this.selectedAttachment) {
        let document = this.documents.find(record => {
          return record.identifier === this.selectedAttachment;
        });

        if (document) {
          this.form.documents.push(document);
          this.resetModalDetails();
        }
      } else {
        this.showAttachmentError = true;
      }
    },

    addDocumentToList() {
      if (this.selectedDocument) {
        let document = this.documentTemplates.find(record => {
          return record.identifier === this.selectedDocument;
        });

        if (document) {
          this.form.documentTemplates.push(document);
          this.resetDocumentModalDetails();
        }
      } else {
        this.showAttachmentError = true;
      }
    },

    openAddAttachmentModal() {
      this.modals.attachment = true;
    },

    openAddDocumentModal() {
      this.modals.document = true;
    },

    detachDocument(document) {
      window
        .swal({
          title: 'Are you sure?',
          text: `This will detach the ${document.type.label} from the payment pack email`,
          type: 'warning',
          showCancelButton: true
        })
        .then(() => {
          let index = this.form.documents.findIndex(record => {
            return record.identifier === document.identifier;
          });

          if (index > -1) {
            this.form.documents.splice(index, 1);
          }
        })
        .catch(error => {});
    },

    detachDocumentTemplate(document) {
      window
        .swal({
          title: 'Are you sure?',
          text: `This will detach ${document.name} from the payment pack email`,
          type: 'warning',
          showCancelButton: true
        })
        .then(() => {
          let index = this.form.documentTemplates.findIndex(record => {
            return record.identifier === document.identifier;
          });

          if (index > -1) {
            this.form.documentTemplates.splice(index, 1);
          }
        })
        .catch(error => {});
    },

    viewDocument(document) {
      this.previewDocument(document.identifier);
    },

    getDocuments() {
      window.Ajax.get(`/incidents/${this.incident}/documents`)
        .then(response => {
          this.documents = response.data;
        })
        .catch(error => {});
    },

    getDocumentTemplates() {
      window.Ajax.get(
        `/credit-hire-organisations/${this.$store.getters.user.tenant.identifier}/document-templates`
      )
        .then(response => {
          this.documentTemplates = response.data;
        })
        .catch(error => {});
    },

    addDocument(type) {
      let document = this.documents.find(document => {
        return document.type.name === type;
      });

      if (document) {
        this.form.documents.push(document);
      }
    },

    addDocumentTemplate(type) {
      let document = this.documentTemplates.find(document => {
        return document.name === type;
      });

      if (document) {
        this.form.documentTemplates.push(document);
      }
    },

    sendEmail() {
      this.form
        .post(`/incidents/${this.incident}/email`)
        .then(response => {
          window.toastify.success(
            'Success!',
            'The email was sent successfully!'
          );
          this.form.reset();
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'There was an issue, please try again'
          );
        });
    }
  }
};
</script>
